import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { images, involvement } from "../../data/site";
export function InvolvementSection() {
  const [primary, ...others] = involvement;
  return <section className="px-3 md:px-5" aria-labelledby="involve-title" data-id="element-86" data-mp="1zcnlcnmc7w5c">
      <div className="mx-auto grid max-w-[1400px] gap-3 lg:grid-cols-2" data-id="element-87" data-mp="1uedqke4iyxk9">
        <div className="relative overflow-hidden rounded-[28px] md:rounded-[36px]" data-id="element-88" data-mp="1qdk4lqan7su0">
          <img src={images.landing} alt="Un pilote souriant atterrit sur une prairie au coucher du soleil" className="absolute inset-0 h-full w-full object-cover" data-id="element-89" data-mp="1ln3q02v36162" />
          <div className="absolute inset-0 bg-navy/45" aria-hidden="true" data-id="element-90" data-mp="1goa9e1ki5u1o" />
          <div className="relative flex min-h-[520px] flex-col justify-end p-8 md:p-12" data-id="element-91" data-mp="1bpyz5pqaphix">
            <h2 id="involve-title" className="max-w-md font-serif text-4xl leading-[1.1] text-cream md:text-5xl" data-id="element-92" data-mp="16q2xvy8zg472">
              Faites partie <span className="italic" data-id="element-93" data-mp="12orb00hhtx2k">de l'histoire.</span>
            </h2>
            <p className="mt-4 max-w-md text-lg text-cream/90" data-id="element-94" data-mp="28bke9dvrtvip">{primary.text}</p>
            <Link to={primary.to} className="mt-8 inline-flex w-fit items-center gap-2 rounded-full bg-lime px-7 py-3.5 font-semibold text-navy transition-colors duration-150 hover:bg-lime-deep" data-id="element-95" data-mp="2d3u30ql5gpje">
              {primary.title}
              <ArrowRightIcon className="h-4 w-4" data-id="element-96" data-mp="23eajdipm4rnh" />
            </Link>
          </div>
        </div>

        <div className="flex flex-col gap-3" data-id="element-97" data-mp="2r4eipdvrq58o">
          {others.map(item => <Link key={item.title} to={item.to} className="group flex flex-1 flex-col justify-between rounded-[28px] bg-sand p-8 transition-colors duration-150 hover:bg-[#EAE1CF] md:rounded-[36px] md:p-12" data-id="element-98" data-mp="2w2g07udjpwi1">
              <div data-id="element-99" data-mp="16n9lcerp943n">
                <h3 className="font-serif text-3xl md:text-4xl" data-id="element-100" data-mp="16mqdxrzody3v">{item.title}</h3>
                <p className="mt-3 max-w-md text-lg text-navy-soft" data-id="element-101" data-mp="1aov6soiauqpg">{item.text}</p>
              </div>
              <span className="mt-8 inline-flex items-center gap-2 font-semibold" data-id="element-102" data-mp="3db8wd4cvy978">
                {item.cta}
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-1" data-id="element-103" data-mp="38bvyzpoe1jqe" />
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}